module.exports = __webpack_public_path__ + "static/media/ic_gears.40f02057.svg";